import { Injectable } from '@angular/core';
import { GetAllResponse } from '../model/restful-api.model';
import { environment } from 'src/environments/environment';
import { API_URL } from '../enums/api-enums';
import { UtilitiesService } from 'src/app/core/services/utilities.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class AdminService {
  constructor(private utilities: UtilitiesService) { }
  
  getAdmin(): Observable<GetAllResponse<any>> {
    const url = environment.portalURL + API_URL.USER_PROFILE_OPERATOR_URL;
    return this.utilities.req.httpGet<GetAllResponse<any>>(url);
  }

  postAdmin(sso): Observable<GetAllResponse<any>> {
    const url = environment.portalURL + API_URL.USER_PROFILE_OPERATOR_URL + `/${sso}`;
    return this.utilities.req.httpPost<GetAllResponse<any>>(url, {});
  }

  deleteAdmin(sso): Observable<GetAllResponse<any>> {
    const url = environment.portalURL + API_URL.USER_PROFILE_OPERATOR_URL + `/${sso}`;
    return this.utilities.req.httpDelete<GetAllResponse<any>>(url);
  }

}
